<template>
  <div>
<!--    <ActionsTableLayout-->
<!--      v-if="dropdown"-->
<!--      :count="6"-->
<!--      :color-btn="colorBtn"-->
<!--      :children="childrenMenu"-->
<!--    >-->
<!--    </ActionsTableLayout>-->
    <div>
      <router-link
        v-if="$can('events.audit')"
        :to="{name: 'events.audit', params: {id: event._id}}"
      >
        <a
          v-if="$can('events.audit')"
          class="btn btn-default btn-fill btn-icon edit btn-sm"
          title="Auditoria do evento"
        ><i class="ti-eye"></i>
        </a>
      </router-link>

      <BtnUploadPhotosEvent
        v-if="config.hasOwnProperty('event') && config.event.hasOwnProperty('hasPhotos') && config.event.hasPhotos && $can('events.photos.upload')"
        btn-class="btn btn-primary btn-fill btn-icon edit btn-sm"
        :event="event"
      />
      <span v-if="showRanking(event.winnerChoiceMode)">
      <router-link
        v-if="$can('ranking.index')"
        :to="{name: 'ranking.index', params: {id: event._id}}"
      >
        <a
          v-if="$can('ranking.index')"
          class="btn btn-success btn-fill btn-icon edit btn-sm"
          title="Gerenciar Ranking"
        ><i class="ti-list-ol"></i>
        </a>
      </router-link>
        <router-link
          v-if="$can('surveys.index')"
          :to="{name: 'surveys.index', params: {id: event._id}}"
        >
        <a
          v-if="$can('surveys.index')"
          class="btn btn-default btn-fill btn-icon edit btn-sm"
          title="Associar pesquisas"
        ><i class="ti-notepad"></i>
        </a>
      </router-link>
      </span>
      <router-link
        v-if="$can('events.edit')"
        :to="{name: 'events.edit', params: {id: event._id}}"
      >
        <a
          v-if="$can('events.index')"
          class="btn btn-warning btn-fill btn-icon edit btn-sm"
          title="Editar"
        ><i class="ti-pencil-alt"></i>
        </a>
      </router-link>
      <router-link
        v-if="$can('events.details')"
        :to="{name: 'events.details', params: {id: event._id}}"
      >
        <a
          v-if="$can('events.details')"
          class="btn btn-info btn-fill btn-icon edit btn-sm"
          title="Gerenciar Evento"
        ><i class="ti-settings"></i>
        </a>
      </router-link>
      <button
        class="btn btn-info btn-fill btn-icon edit btn-sm"
        @click="getOnlineRegisterLink(event._id)"
        title="Cadastro Online"
        type="button"
      >
        <i class="ti-share-alt"></i>      </button>
      <button
        v-if="$can('events.remove')"
        class="btn btn-danger btn-fill btn-icon edit btn-sm"
        @click="handleDelete({id: event._id})"
        title="Remover"
        type="button"
      >
        <i class="ti-trash"></i>
      </button>
    </div>
  </div>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex'
  import swal from 'sweetalert2'
  import BtnUploadPhotosEvent from 'src/pages/Events/UploadPhotos/BtnUploadPhotosEvent'
  import ActionsTableLayout from 'src/components/Layout/ActionsTableLayout'
  import RouterButton from 'src/components/Layout/RouterButton'

  export default {
    name: 'table-actions-events',

    mounted () {
      if (!this.project || !this.project._id) {
        this.fetchProject('config')
      }
    },

    components: {
      BtnUploadPhotosEvent,
      ActionsTableLayout,
      RouterButton
    },

    props: {
      dropdown: {
        default: true
      },
      showRanking: {
        required: true
      },
      handleDelete: {
        required: true
      },
      event: {
        required: true
      },
      config: {
        required: true
      }
    },
    computed: {
      ...mapGetters('project', ['eventLabel', 'project']),
      colorBtn: function () {
        if (this.event.status === 1) {
          return `btn-success`
        }
        if (this.event.status === 2) {
          return `btn-danger`
        }
      },

      childrenMenu: function () {
        const children = []

        if (this.config.hasOwnProperty('event') && this.config.event.hasOwnProperty('hasPhotos') && this.config.event.hasPhotos && this.$can('events.photos.upload')) {
          children.push(this.getBtnUploadPhotos())
        }

        if (this.showRanking(this.event.winnerChoiceMode)) {
          if (this.$can('ranking.index')) {
            children.push(
              this.getRouterButton('ranking.index', {id: this.event._id}, 'Gerenciar Ranking', 'ti-list-ol', 'success')
            )
          }
          if (this.$can('surveys.index')) {
            children.push(
              this.getRouterButton('surveys.index', {id: this.event._id}, 'Associar Pesquisas', 'ti-notepad', 'default')
            )
          }
        }

        if (this.$can('events.details')) {
          children.push(
            this.getRouterButton('events.details', {id: this.event._id}, 'Gerenciar Evento', 'ti-settings', 'info')
          )
        }

        if (this.$can('events.edit')) {
          children.push(
            this.getRouterButton('events.edit', {id: this.event._id}, 'Editar ' + localStorage.getItem('eventLabel'), 'ti-pencil-alt', 'warning')
          )
        }

        if (this.$can('events.remove')) {
          children.push(
            {
              component: 'action-button-click-stateless',
              data: {
                props: {
                  to: {
                    name: 'events.remove',
                    params: {id: this.event._id}
                  },
                  title: 'Remover ' + localStorage.getItem('eventLabel'),
                  classStyle: {
                    btn: true,
                    'btn-block': true,
                    'btn-flat': true,
                    'btn-icon': false,
                    [`btn-danger`]: true
                  },
                  iconClass: 'ti-trash',
                  params: {
                    id: this.event._id
                  },
                  handleEvent: {
                    click: this.handleDelete
                  }
                }
              }
            }
            // {
            //   name: 'events.remove',
            //   title: 'Remover Evento',
            //   color: 'danger',
            //   icon: 'ti-trash',
            //   component: 'action-button-click-stateless',
            //   props: {
            //     params: {
            //       id: this.event._id
            //     },
            //     handleEvent: {
            //       click: this.handleDelete
            //     }
            //   }
            // }
          )
        }

        return children
      }
    },
    methods: {
      ...mapActions('project', {fetchProject: 'fetchOne'}),
      getRouterButton (name, params, title, icon, color) {
        return {
          component: RouterButton,
          data: {
            props: {
              to: {
                name,
                params
              },
              title,
              classStyle: {
                btn: true,
                'btn-block': true,
                'btn-flat': true,
                'btn-icon': false,
                [`btn-${color}`]: true
              },
              iconClass: icon
            }
          }
        }
      },

      getBtnUploadPhotos () {
        return {
          component: BtnUploadPhotosEvent,
          data: {
            class: 'action-btn',
            props: {
              event: this.event
            }
          }
        }
      },

      getOnlineRegisterLink ($eventId) {
        const link = this.config.projectOnlineRegister + '/cadastro/' + $eventId

        if (/https?:\/\//g.test(link)) {
          return swal({
            html: `<a href="${link}" target="_blank" rel="noopener noreferrer">${link}</a>`,
            cancelButtonText: 'Voltar',
            showCancelButton: true,
            showConfirmButton: false,
            showCloseButton: true
          })
        }
        return swal({
          title: 'Link inválido',
          type: 'error'
        })
      }
    }
  }
</script>

<style scoped>
  a, button, .btn-mb-5 {
    margin-bottom: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Events/TableActionsEvents.vue